import { LOCALE_ID, NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, DecimalPipe, registerLocaleData } from '@angular/common';
import * as fromComponents from './components';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '@core/core.module';
import { HomeComponent } from './home.component';
import { OfferJunctureComponent } from './components/offer-juncture/offer-juncture.component';
import { FamilyJunctureComponent } from './components/family-juncture/family-juncture.component';
import { UserdataJunctureComponent } from './components/userdata-juncture/userdata-juncture.component';
import { SocsecurityJunctureComponent } from './components/socsecurity-juncture/socsecurity-juncture.component';
import { FinalpaymentJunctureComponent } from './components/finalpayment-juncture/finalpayment-juncture.component';
import { ContactinfoJunctureComponent } from './components/contactinfo-juncture/contactinfo-juncture.component';
import { PayfrequencyJunctureComponent } from './components/payfrequency-juncture/payfrequency-juncture.component';
import { ConditionsJunctureComponent } from './components/conditions-juncture/conditions-juncture.component';
import { CaptchaJunctureComponent } from './components/captcha-juncture/captcha-juncture.component';
import { NoworlaterJunctureComponent } from './components/noworlater-juncture/noworlater-juncture.component';
import localeHu from '@angular/common/locales/hu';
import { BannerJunctureComponent } from './components/banner-juncture/banner-juncture.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { FooterModule } from '../main/components/footer/footer.module';
import { BannerInfoComponent } from './components/banner-juncture/banner-info/banner-info.component';
registerLocaleData(localeHu);

@NgModule({
  declarations: [
    fromComponents.components,
    HomeComponent,
    OfferJunctureComponent,
    FamilyJunctureComponent,
    UserdataJunctureComponent,
    SocsecurityJunctureComponent,
    FinalpaymentJunctureComponent,
    ContactinfoJunctureComponent,
    PayfrequencyJunctureComponent,
    ConditionsJunctureComponent,
    CaptchaJunctureComponent,
    NoworlaterJunctureComponent,
    BannerJunctureComponent,
    BannerInfoComponent],
  exports: [fromComponents.components, HomeComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, CoreModule, FontAwesomeModule, NgbModule, BrowserAnimationsModule, FooterModule, TranslateModule],
  providers: [DecimalPipe, { provide: LOCALE_ID, useValue: 'hu-HU' }]
})
export class HomeModule { }
